module.exports = __webpack_public_path__ + "img/play.a2e99248.svg";